import React, { Component } from "react";
import Chart from "react-apexcharts";

class ScatterPlot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.chartData,
      chartOptions: this.props.chartOptions,
    });
  }

  componentDidUpdate(prevProps) {
    // Check if `chartData` has changed
    if (this.props.chartData !== prevProps.chartData) {
      this.setState({ chartData: this.props.chartData });
    }

    // Check if `chartOptions` has changed
    if (this.props.chartOptions !== prevProps.chartOptions) {
      this.setState({ chartOptions: this.props.chartOptions });
    }
  }

  render() {
    return (
      <div className="scatter-plot">
        <Chart
          options={this.state.chartOptions}
          series={this.state.chartData}
          type="scatter"
          width="100%"
          height="400px"
        />
      </div>
    );
  }
}

export default ScatterPlot;
